/** F1–F12: the same function keys the chat box lets through to the game
 *  (CHAT_PASSTHROUGH_KEYS in Input.ts). A box or panel that keeps key presses
 *  from the game lets these carry on to it: the game cancels their browser
 *  defaults (F5 would reload the page) and runs their binds. */
export const FUNCTION_KEY = /^F([1-9]|1[0-2])$/;
